import { render } from "./view-class.vue?vue&type=template&id=7676f6a2&lang=html"
import script from "./view-class.vue?vue&type=script&lang=js"
export * from "./view-class.vue?vue&type=script&lang=js"

import "./view-class.vue?vue&type=style&index=0&id=7676f6a2&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__